import SingleQuestionQuizScreenComponent from '@/features/quiz/screens/single-question-quiz-screen'
import EDAdCopyScreen from '@/features/quiz/ed/ed-ad-copy-screen'
import EDFactsScreen from '@/features/quiz/ed/ed-facts-screen'
import QuizAuthenticationScreen, {
  AuthenticationScreenProps,
} from '@/features/quiz/screens/quiz-authentication-screen'
import BodyCompositionScreen from '@/features/quiz/screens/body-composition-screen'
import {
  type QuizScreen,
  ED_CONFIDENCE_LEDGER_KEY,
  WL_CONSISTENCY_LEDGER_KEY,
} from '@/features/quiz/quiz-screen'
import DateOfBirthScreen from '@/features/quiz/screens/date-of-birth-screen'
import BillingDetailsScreen, {
  BillingDetailsScreenProps,
} from '@/features/quiz/screens/billing-details-screen'
import MedicareCardScreen from '@/features/quiz/screens/medicare-card-screen'
import ServiceSelectorScreen from '@/features/quiz/ed/service-selector-screen'
import MhlServiceSelectorScreen from '@/features/quiz/mhl/service-selector-screen'
import WlServiceSelector from '@/features/quiz/wl/service-selector-screen'
import WlConsistencyLedgerScreen from '@/features/quiz/wl/consistency-ledger-screen'
import EdConfidenceLedgerScreen from '@/features/quiz/ed/confidence-ledger-screen'

type Props = {
  screen: QuizScreen
} & AuthenticationScreenProps &
  BillingDetailsScreenProps

export default function TreatmentQuizScreenRenderer(props: Props) {
  const { screen } = props

  if (screen.type === 'single-question') {
    const question = screen.question
    const format =
      props.treatmentType === 'wl' &&
      question.id === 'diagnosed_with_diseases_2' &&
      question.type === 'multiple-choice'
        ? {
            ...question,
            choices: question.choices.filter(
              (choice) => choice.key !== 'diagnosed_with_diseases_2_depression',
            ),
          }
        : question

    return <SingleQuestionQuizScreenComponent {...props} format={format} />
  }

  switch (screen.id) {
    case ED_CONFIDENCE_LEDGER_KEY:
      return <EdConfidenceLedgerScreen {...props} />

    case WL_CONSISTENCY_LEDGER_KEY:
      return <WlConsistencyLedgerScreen {...props} />

    case 'BillingDetails':
      return <BillingDetailsScreen {...props} />

    case 'Authentication':
      return <QuizAuthenticationScreen {...props} />

    case 'BodyComposition':
      return <BodyCompositionScreen {...props} />

    case 'DateOfBirth':
      return <DateOfBirthScreen {...props} screenId={screen.id} />

    case 'EdAdCopy':
      return <EDAdCopyScreen {...props} />

    case 'EdFacts':
      return (
        <EDFactsScreen
          {...props}
          lines={[
            "You're not alone",
            '50% of the men in Australia have experienced ED at some point in their life.',
          ]}
        />
      )

    case 'MedicareCard':
      return <MedicareCardScreen {...props} />

    case 'EdServiceSelector':
      return <ServiceSelectorScreen {...props} />

    case 'MhlServiceSelector':
      return <MhlServiceSelectorScreen {...props} />

    case 'WlServiceSelector':
      return <WlServiceSelector {...props} />
  }
}
